/* eslint-disable @typescript-eslint/prefer-for-of */
import { Component, OnInit, ViewChild } from '@angular/core';
import { ArticlesService } from '../../../services/articles.service';
import { MetaProvider } from '../../../services/meta.provider';
import { GaEventTrackerProvider } from '../../../services/gaeventtracker.provider';
import { Multitenant } from '../../../services/multitenant.provider';
import { Book } from '../../../models/book.model';
import { PopUp } from '../../../models/popup.model';
import { AuthProvider } from '../../../services/auth.provider';
import { PopUpService } from '../../../shared/components/pop-up/pop-up.service';
import { IonContent } from '@ionic/angular';
import { ActivatedRoute, Router } from '@angular/router';
import { sharedItems } from 'src/app/shared/utils';

@Component({
  selector: 'app-book-detail',
  templateUrl: 'book-detail.html',
  styleUrls: ['book-detail.scss']
})
export class BookDetailPage implements OnInit {
  @ViewChild(IonContent) public content: IonContent;
  public book: Book;
  public isActivePage: string;
  public themeClass: string;
  public slug: string;
  public comment = true;
  public tempPopUp: boolean;
  public popup: PopUp = new PopUp();

  constructor(
    private actRoute: ActivatedRoute,
    private router: Router,
    private articlesService: ArticlesService,
    private meta: MetaProvider,
    private multiTenant: Multitenant,
    private ga: GaEventTrackerProvider,
    private auth: AuthProvider,
    private popUpService: PopUpService
  ) { }

  ngOnInit(): void {
    this.actRoute.paramMap.subscribe( paramMap => {
      this.slug = paramMap.get('slug');
      this.getBookDetail(this.slug);
    });
  }

  ionViewWillEnter() {
    this.isActivePage = 'menu';
    this.themeClass = this.multiTenant.getDomainClass();
    setTimeout(() => { this.clearImageHeight(); }, 2000);
  }

  ionViewDidEnter() {
    this.meta.clearHead();

    if ( !this.auth.isAuthenticated() && this.popUpService.havePassedSevenDays() && this.multiTenant.getDomainClass() === 'playbacpresse') {
      this.tempPopUp = true;
      this.popup.type = 'unIdentifiedUser';
    }
  }

  getBookDetail(slug: string) {
    return this.articlesService.getBookDetail(slug).subscribe(
      response => this.book = response[0]
    );
  }

  goToExtract(url: string, bookTitle: string) {
    this.ga.trackEvent(this.themeClass, 'Lire un extrait', bookTitle, 0);
    window.open(url, '_blank');
  }

  goToBookList(newspaper) {
    if (this.multiTenant.getDomainClass() !== 'playbacpresse') {
      this.router.navigate(['actu-livres']);
    } else {
      switch (newspaper) {
        case 'lepq':
          window.open( 'https://lepetitquotidien.playbacpresse.fr/actu-livres', '_blank' );
          break;
        case 'mquo':
          window.open( 'https://monquotidienvideo.playbacpresse.fr/actu-livres', '_blank' );
          break;
      }
    }
  }

  clearImageHeight() {
    const images = document.getElementsByTagName('img');
    if (images.length > 0) {
      for (let i = 0; i < images.length; i++) {
        if (parseInt(images[i].style.height, 10) > 0) {
          images[i].style.height = 'auto';
        }
      }
    }
  }

  headerNotify(message: string): void {
    this.tempPopUp = true;
    this.popup.type = 'featureToCome';
  }

  onNotifyPopUp(message: string): void {
    this.tempPopUp = false;
  }

  getInclude() {
    if ( !this.auth.isAuthenticated() || (this.auth.isAuthenticated() && this.auth.getActiveProfile() === 'Children') ) {
      return sharedItems(this.book.book_newspaper);
    } else {
      return ['facebook', 'twitter', 'email', 'whatsapp'];
    }
  }
}
